import { render, staticRenderFns } from "./DeviceUpgradeModal.vue?vue&type=template&id=2d0140b4&scoped=true"
import script from "./DeviceUpgradeModal.vue?vue&type=script&lang=js"
export * from "./DeviceUpgradeModal.vue?vue&type=script&lang=js"
import style0 from "./DeviceUpgradeModal.scss?vue&type=style&index=0&id=2d0140b4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0140b4",
  null
  
)

export default component.exports